import { NativeModules } from 'react-native';
import { parse } from 'qs';
export default function (rootTag) {
    if (typeof rootTag !== 'number') {
        return {};
    }
    try {
        const bundleInfo = NativeModules?.KRNBasic?.getBundleInfo?.(rootTag);
        return parse(bundleInfo);
    }
    catch (error) {
        return {};
    }
}
